window.addressFormatter = function(value, row) {
    let html = '';
    if (value) {
        if (can('admin.relations.addresses.details')) {
            html += '<a href="/admin/relations/show/addresses/show/'+row.address_id+'">';
            html += value;
            html += '</a>';
        } else {
            html += value;
        }
    }
    return html;
}
